export enum BillingMethod {
    BankDraft = "Bank Draft"
}
